import {
  TableCell,
  TableContainer,
  TableRow,
  tableCellClasses,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const StyledTableContainer = styled(TableContainer)(() => ({
  width: '100%',
  paddingBottom: '10px',
}));

export const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: '600',
    fontSize: '16px',
    color: '#F2F2F2',
    backgroundColor: theme.palette.secondary.main,
  },
  '&:first-of-type': {
    borderRightTopRadius: 16,
  },
}));

interface StyledTableCellProps {
  unread: 'true' | 'false';
}

export const StyledTableCell = styled(TableCell)<StyledTableCellProps>(
  ({ unread }) => ({
    color: '#1A1A1A',
    padding: '12px',
    fontSize: '14px',
    fontWeight: unread === 'true' ? 600 : 400,
  })
);

export const Row = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  border: '1px solid #1A1A1A',
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    background: alpha(theme.palette.common.grey, 0.2),
  },
}));
